<template>
  <div v-if="body_show">
    <div class="men_infortop">
      <a @click="statistical_l"><img src="@a/logos.png" /></a>
    </div>
    <div class="wechat">
      {{data.name}}
    </div>
    <div class="wechat_m" v-if="data.wechat" v-html="data.wechat"></div>
    <div class="wechat_m" v-else>
      <h2 style="margin-bottom: 20px;">请扫描二维码添加班主任微信，<br/>发送验证消息“新生报到”</h2>
      <h3>（如果班主任没有及时通过你的请求，不要着急，<br/>一定是添加的人太多了…而且…她会比你着急）</h3>
      <img :src="data.default_wechat" />
      <h4>（识别或扫描二维码，添加班主任）</h4>
    </div>
  </div>
</template>
<script>
import {
  searchwechat
} from "@/api/course";
import {
  statistics
} from "@/api/public";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        cid: "",
        data: {},
        body_show: false
      }
    },
    methods: {
      pullData() {
        this.cid = this.$route.query.cid;
        searchwechat({
            cid: this.cid
          })
          .then((data) => {
            this.body_show = true;
            this.data = data;
          })

      },
      statistical_l() {
        statistics({
          type: "lefticon"
        }).then(data => {
          this.$router.push({path:"/index"})
        });
      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.men_infortop {
  width: 750px;
  line-height: 1;
  padding: changeRem(.4)+px changeRem(.6)+px;
  color: #EB5032;
  font-size: changeRem(.68)+px;
  text-align: left;
  a {
    display: inline-block;
    width: changeRem(4.8)+px;
    img {
      width: 100%;
    }
  }
}

.wechat {
  width: 750px;
  height: changeRem(2.4)+px;
  line-height: changeRem(2.4)+px;
  background: linear-gradient(90deg, rgba(245, 127, 23, 1) 0%, rgba(235, 80, 50, 1) 100%);
  color: #fff;
  font-size: 34px;
  text-align: center;
}

.wechat_m {
  width: 750px;
  text-align: center;
  padding-top: changeRem(1.4)+px;
  h2 {
    color: #EB5032;
    font-size: changeRem(.64)+px;
    line-height: changeRem(.8)+px;
}
  h3 {
    color: #666;
    font-size: changeRem(.52)+px;
    line-height: changeRem(.72)+px
  }
  img {
    width: changeRem(8.52)+px;
    height: changeRem(8.52)+px;
    margin: 0 auto;
    margin-top: changeRem(.96)+px
  }
  h4 {
    color: #999;
    font-size: changeRem(.56)+px;
    line-height: changeRem(.72)+px;
    margin-top: changeRem(.2)+px;
}
}
</style>
<style>
  .wechat_m img{
    width: 426px;
    height: 426px;
    margin: 0 auto;
    margin-top: 48px
  }
</style>
